<template>
  <main>
    <PageIntro
      :heading="'Your <span>My Latics</span> account'"
      :body="'<p>Please enter your email and we\'ll send you a new verfication code.</p>'" />
    <SendConfirmCodeForm />
    <FooterShout :type="'register'"/>
  </main>
</template>

<script>
  import SendConfirmCodeForm from '@/components/SendConfirmCodeForm.vue'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      SendConfirmCodeForm,
      PageIntro,
      FooterShout
    }
  }
</script>
